import Referral from "@/orm/models/Company/Referral";
import { computed } from '@vue/composition-api';

export default function useReferral() {
  const referralInfo = computed(() => Referral.all());

  async function fetchReferralInfo() {
    await Referral.api().fetchReferralInfo()
  }

  return {
    fetchReferralInfo,
    referralInfo
  };
}
